export const isNumber = (value: string | number | undefined): boolean => {
  if (value === undefined) return false;
  if (typeof value === 'number') return true;
  const trimValue = value.trim();
  if (trimValue.length === 0) return false;
  const onlyHasNumbers = !trimValue.match(/[^0-9\.]/);
  const onlyHasSingleDotOrZeroDot = trimValue.split('.').length <= 2;
  return onlyHasNumbers && onlyHasSingleDotOrZeroDot;
};
